module.exports = __webpack_public_path__ + "static/media/kidedu.8f9a90ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/kidedu.png
// module id = 406
// module chunks = 0